function e(t) {
  return t;
}
export {
  e as default
};
